<template>
  <div class="text-center">
    <v-img height="400" contain src="../../assets/chatwelcome.png"></v-img>
    <div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'chatwelcome'
}
</script>

<style scoped>

</style>
